import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule, NgClass } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { IconService } from './icon.service';

@Component({
  selector: 'NiIcon',
  standalone: true,
  styles: [
    `
:host {
  display: flex;
  justify-content: center;
  align-items: center;
}
.icon {
  width: 1.25rem;
  height: 1.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
:host ::ng-deep mat-icon {
  width: 100%;
  height: 100%;
  font-size: 1.25rem;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
    `
  ],
  imports: [CommonModule, HttpClientModule, RouterModule, MatIconModule, NgClass],
  template: '<mat-icon *ngIf="icon" [svgIcon]="icon" class="icon" [ngClass]="iconClass" (click)="onClick.emit($event)"></mat-icon>'
})
export class NiIconComponent implements OnChanges {
  @Input() icon: string = '';
  @Input() iconClass: string = '';
  @Output() onClick: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();

  constructor(private readonly iconService: IconService) {}

  ngOnChanges() {
    if (this.icon) {
      this.iconService.registerIcon(this.icon);
    }
  }
}